import React from 'react';
import { DropDown } from './common';
import {validatable} from 'components/utils';

class DropDownQuyTrinh extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label } bindValidator={this} channel="formTaoDon" require={this.props.require} selectedValue={this.props.selectedValue} options={ this.props.data } keyName='giaTri' valueName='ten' className={this.props.className} onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } />
    );
  }
}

DropDownQuyTrinh.defaultProps = {
  label: 'Quy trình',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: [
    {giaTri: 'UBND_TP', ten: 'uỷ ban nhân dân Tỉnh'},
    {giaTri: 'SO_BAN_NGANH', ten: 'Sở ban ngành'}
  ]
}

export default validatable(DropDownQuyTrinh);


// WEBPACK FOOTER //
// ./src/components/tt-forms/DropDownQuyTrinh.jsx